import { ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import CheckoutTextWithTooltip from '../../components/shared/CheckoutTextWithTooltip';

import styles from './DutiesMessages.scss';

type DutiesMessages = Record<string, ReactNode | undefined>;
//DDP means taxes paid at checkout
//DAP is default means taxes not paid at checkout and maybe paid at arrival
export const DutiesMessages: DutiesMessages = {
    DDP: (
        <>
            <FormattedMessage
                id="shared.delivery.PreQuoteDutiesDescription.DDP"
                defaultMessage="Import duties and taxes paid at checkout."
            />
            <CheckoutTextWithTooltip
                addQuestionMark
                tooltip={
                    <FormattedMessage
                        id="shared.delivery.PreQuoteDutiesDescription.DDP.tooltip"
                        defaultMessage="Applicable duties, taxes, and customs fees are included in your order total. You will not be required to pay additional fees upon arrival."
                    />
                }
                customTooltipSize="large"
                questionMarkIconClass={styles.questionMarkIcon}
            />
        </>
    ),
    DAP: (
        <>
            <FormattedMessage
                id="shared.delivery.PreQuoteDutiesDescription.DAP"
                defaultMessage="Import duties may be collected upon arrival."
            />
            <CheckoutTextWithTooltip
                addQuestionMark
                tooltip={
                    <FormattedMessage
                        id="shared.delivery.PreQuoteDutiesDescription.DAP.tooltip"
                        defaultMessage="You may be required to to pay applicable duties, taxes, and customs to the shipping carrier upon receipt."
                    />
                }
                customTooltipSize="large"
                questionMarkIconClass={styles.questionMarkIcon}
            />
        </>
    ),
};

export const DDPCheckoutDisclaimer = (
    <div>
        <FormattedMessage
            id="customs.messaging.checkout.allDutiesIncluded"
            defaultMessage="All duties and taxes are included. The price you see is the price you pay."
        />
    </div>
);

export const DAPCheckoutDisclaimer = (
    <div>
        <FormattedMessage
            id="customs.messaging.checkout.allDutiesNotIncluded"
            defaultMessage="Additional duties and taxes may apply and be collected upon arrival."
        />
    </div>
);
